import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { RestService } from '../../services/rest/rest.service';
@Injectable()
export class BrightcovePlayerRestService {
  private readonly restService = inject(RestService);

  triggerSessionAlive(): Observable<void> {
    return this.restService.getResource('session.keepalive').get();
  }
}
